import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientInvite, QueryClientInviteArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TData = ClientInvite;
type TVariables = QueryClientInviteArgs;

const MOCK: TVariables = { token: '' };

export const useClientInvite = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query getClientInvite($token: String!) {
      clientInvite(token: $token) {
        user {
          email
          firstName
          lastName
        }
        clientAccount {
          name
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['clientInvite', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
